var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text-field',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"type":"email"},on:{"input":function (v) { return _vm.$emit('input', v); }}},'app-text-field',[_vm.emailFieldDefaults, _vm.$attrs],false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }